import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._g({ref:_vm.name,class:_vm.danger?'white--text':'onSecondary--text',attrs:{"name":_vm.name,"color":_vm.danger?'red':_vm.color,"loading":_vm.loading,"disabled":_vm.disabled}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }